/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/17
 * Time: 17:38
 * Desc: 云店设置-分类配置
 */

import { Component, Vue } from 'vue-property-decorator';

// 子组件
import GoodsCategory from '@/views/components/goodsCategory/goodsCategory.vue'; // 商品分类配置
import IconCategory from '@/views/components/iconCategory/iconCategory.vue'; // 快捷图标配置
import sizeExplain from '@/views/components/sizeExplain/sizeExplain.vue'; // 尺码对照表
import FilterItemManager from '@/views/components/filterItemManager';
import sizeMapping from '@/views/components/sizeMapping/sizeMapping';
@Component({
  components: {
    GoodsCategory,
    IconCategory,
    sizeExplain,
    FilterItemManager,
    sizeMapping,
  },
})
export default class CategoryConfig extends Vue {
  /* 数据 */

  /**
   * 当前类型
   * @type {string}
   */
  public curTab = '4';

  /**
   * 运营模式
   * 1 镜像店单店 2 镜像店千店 3 云商城单店 4 云商城千店
   * @type {number}
   */
  public mode = 0;

  /* 方法 */

  /**
   * 类型切换
   * @param {string} index
   */
  public onSwitchTab(index: string): void {
    this.curTab = index;
    localStorage.setItem('curTab', index);
  }

  /* 周期 */

  /**
   * 当组建加载时
   */
  public created() {
    this.mode = +this.$route.params.mode;
    // 获取当前页索引
    this.curTab = localStorage.getItem('curTab') ? localStorage.getItem('curTab') : '4';
  }
}
